

  export class TableColSave {
      Key:string;
      show:boolean = true;
      name:string;
      kolejnosc:number;
      login:string;

      constructor(Key:string, name:string, show:boolean, kolejnosc:number, login:string){
        this.Key = Key;
        this.name = name;
        this.show = show;
        this.kolejnosc = kolejnosc;
        this.login = login;
      }
  }